import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { MechanismReveal } from './components/MechanismReveal';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: unknown;
  }
}
export function App() {
  useEffect(() => {
    // Inject Meta Pixel script
    if (typeof window.fbq === 'function') return; // Already loaded
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1432168351700984');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Noscript fallback
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1432168351700984&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  return <div className="min-h-screen bg-night-500 text-night-50 font-sans selection:bg-amber-warm/30 selection:text-amber-glow" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainPoints data-id="element-3" />
        <MechanismReveal data-id="element-4" />
        <OfferSection data-id="element-5" />
      </main>
      <Footer data-id="element-6" />
    </div>;
}